import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { StorageService, UserService } from '@services/services.module';
import { CookieService } from '@services/cookie/cookie.service';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Constants } from '@app/constants/constants';

@Component({
  selector: 'app-login',
  templateUrl: './login-manual.component.html',
  styleUrls: ['./login-manual.component.scss']
})
export class LoginManualComponent implements OnInit {

  logOutSession: any;
  loginForm: FormGroup;

  constructor(
    private titleService: Title,
    private activatedRoute: ActivatedRoute,
    private translate: TranslateService,
    private _user: UserService,
    private cookie_service: CookieService,
    private storage: StorageService,
    private router: Router,
    private fb: FormBuilder)
   {
    this.loginForm = this.fb.group({
      user: ['', [Validators.required]],
      password: ['', [Validators.required]],
    });
    this.cookie_service.deleteAll();
    // this._user.logOut();
   }

  ngOnInit() {
    // For security we delete all data in session storage
    this.storage.removeAll();
    this.translate.get(this.activatedRoute.snapshot.data['title']).subscribe((res: string) => {
      this.titleService.setTitle(res);
    });

    // observable para controlar la expulcion por inactividad del usuario
    this._user.sessionExpired$.subscribe(data => {
        this.logOutSession = data;
    });
  }

  doLogin() {
    //this._user.logIn();
    this._user.manualLogin(this.loginForm.value).subscribe(res => {
      /* Susceptible de cambiar dependiendo de lo que devuelva el nuevo endpoint */
      //console.log("respuesta de login manual",res);
      if (res)
        {

          this.storage.set("EMAIL", res.email);
          this.storage.set("PROFILE_ID", res.profileId);
          this.storage.set("EMPLOYEE_NUMBER", res.employeeNumber);
          this.storage.set("EMPLOYEE_NAME", res.name);

        console.log("nevagando a imputaciones");
        this.router.navigate(['/imputaciones']);
      }
    })
  }
}
